<app-loader [isBusy]="!model || isBusy">
    <ng-template>
        <app-action-bar [items]="actionBar"></app-action-bar>
        <app-content-header [title]="title" [breadcrumb]="breadcrumb"></app-content-header>

        <div class="card mt-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-3">
                        <app-control label='Name' [(ngModel)]="model.name" [required]="true"></app-control>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <kendo-tabstrip>
                    <kendo-tabstrip-tab title="{{'Permissions'|translate}}" [selected]="true">
                        <ng-template kendoTabContent>
                            <div class="row mt-3" *ngIf="editMode">
                                <div class="col-3">
                                    <app-control #selectedPermission type="codelist"
                                        codelist="Permission"></app-control>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-success btn-sm float-right"
                                        (click)="addPermission(selectedPermission.value)"
                                        [disabled]="!selectedPermission.value || permissionExists(selectedPermission.value)">
                                        <fa-icon icon="plus"></fa-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <app-grid [data]="model.permissions" class="mb-2">
                                        <kendo-grid-column field="id" title="{{'Name'|translate}}">
                                            <ng-template kendoGridCellTemplate let-row>
                                                <span>{{row.permission.fullName}}</span>
                                            </ng-template>
                                        </kendo-grid-column>
                                        <kendo-grid-column *ngIf="editMode" field="id" title="" [width]="100">
                                            <ng-template kendoGridCellTemplate let-row>
                                                <button class="btn btn-danger btn-xs" (click)="removePermission(row.permission.id)">
                                                    <fa-icon icon="trash"></fa-icon>
                                                </button>
                                            </ng-template>
                                        </kendo-grid-column>

                                    </app-grid>
                                </div>
                            </div>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{'Organizations'|translate}}" *ngIf="!createMode">
                        <ng-template kendoTabContent>
                            <div class="row mt-3">
                                <div class="col">
                                    <app-grid [data]="organizations" class="mb-2">
                                        <kendo-grid-column field="name" title="{{'Name'|translate}}">
                                        </kendo-grid-column>
                                    </app-grid>
                                </div>
                            </div>
                        </ng-template>
                    </kendo-tabstrip-tab>
                </kendo-tabstrip>
            </div>
        </div>
    </ng-template>
</app-loader>
